





























































import { Component, Vue, PropSync, Prop, Watch } from "vue-property-decorator";
import { patologia } from "@/shared/dtos/patologia";
import patologiaModule from "@/store/modules/patologia-module";
@Component({})
export default class PatologiasListaSelect extends Vue {
  @Prop() id_paciente!: number;
  @PropSync("dialog", { type: Boolean }) syncedDialog!: Boolean;
  @PropSync("seleccioandas", { type: Number })
  syncedseleccioandas!: patologia[];
  public search: string = "";
  public selected: patologia[] = [];

  public created() {
    patologiaModule.getpatologiastopaciente(this.id_paciente);
  }
  public get patologias() {
    return patologiaModule.patologias;
  }

  public get headers() {
    return [
      {
        text: "Nombre",
        align: "start",
        value: "nombre_patologia"
      },
      { text: "Mastica", value: "puede_masticar" }
    ];
  }
  @Watch("syncedDialog")
  public cleanSelected() {
    if (!this.syncedDialog) {
      this.selected = [];
    } else {
      patologiaModule.getpatologiastopaciente(this.id_paciente);
    }
  }
  public Cancelar() {
    this.syncedDialog = false;
  }
  public Aceptar() {
    this.syncedDialog = false;
    this.syncedseleccioandas = this.selected;
    try {
      if (
        this.selected !== undefined &&
        this.selected !== null &&
        this.selected.length > 0
      ) {
        this.$emit("Aceptado", this.selected);
      }
    } catch (error) {}
  }
}
